import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { PlayerData } from '../../types/player';

interface ReferencedArticlesSectionProps {
  playerData: PlayerData;
}

export const ReferencedArticlesSection: React.FC<ReferencedArticlesSectionProps> = ({ playerData }) => {
  // Check if debug articles exist
  const hasDebugArticles = playerData?.debug?.summary?.all_articles && 
    playerData.debug.summary.all_articles.length > 0;

  if (!hasDebugArticles) {
    return null;
  }

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="referenced_articles" className="border-b border-gray-700">
        <AccordionTrigger className="px-4">
          <div className="flex items-center gap-2">
            <span>Referenced Articles</span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="px-4">
          <div className="rounded bg-[#26222E] p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {playerData.debug.summary.all_articles.map((article: any, index: number) => (
                <a 
                  key={index}
                  href={article.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-start p-2 rounded-md hover:bg-[#121212] transition-colors"
                >
                  <div className="flex-shrink-0 w-5 h-5 mt-0.5 text-[#4E46FF]">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M4.25 5.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0112.75 17h-8.5A2.25 2.25 0 012 14.75v-8.5A2.25 2.25 0 014.25 4h5a.75.75 0 010 1.5h-5z" clipRule="evenodd" />
                      <path fillRule="evenodd" d="M6.194 12.753a.75.75 0 001.06.053L16.5 4.44v2.81a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.553l-9.056 8.194a.75.75 0 00-.053 1.06z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-2">
                    <span className="text-sm text-[#4E46FF] hover:underline break-words">
                      {article.title}
                    </span>
                    <div className="text-xs text-[#CECFD2] mt-1">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-[#121212] text-[#CECFD2]">
                        {article.category}
                      </span>
                      {article.from_database && (
                        <span className="inline-flex items-center ml-2 px-2 py-0.5 rounded text-xs font-medium bg-[#26222E] text-[#4E46FF]">
                          From Database
                        </span>
                      )}
                      {article.historical && (
                        <span className="inline-flex items-center ml-2 px-2 py-0.5 rounded text-xs font-medium bg-[#26222E] text-[#CECFD2]">
                          Historical
                        </span>
                      )}
                      {article.scrape_date && article.scrape_date !== 'Unknown' && (
                        <span className="inline-flex items-center ml-2 px-2 py-0.5 rounded text-xs font-medium bg-[#121212] text-[#CECFD2]">
                          {new Date(article.scrape_date).toLocaleDateString()}
                        </span>
                      )}
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};